import { useState } from 'react';
import { pharmacies } from '../../../mocks/product';

const PharmacyMap = () => {
  const [filterToday, setFilterToday] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const color = '#ff2d78';

  const filtered = filterToday ? pharmacies.filter(p => p.canPickupToday && p.inStock) : pharmacies;

  const selectedPharmacy = pharmacies.find(p => p.id === selectedId) || null;

  return (
    <section className="py-16 px-4 md:px-8 lg:px-12" style={{ background: '#070710' }}>
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <h2 className="font-orbitron font-black text-2xl md:text-3xl text-white mb-1">
              АПТЕКИ С ТОВАРОМ
            </h2>
            <p className="font-mono text-xs text-white/30">Найдено в {pharmacies.filter(p => p.inStock).length} аптеках рядом с вами</p>
          </div>

          <button
            onClick={() => setFilterToday(f => !f)}
            className="whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full font-mono text-xs tracking-wider cursor-pointer transition-all duration-300"
            style={filterToday
              ? { background: '#39ff14', color: '#050508', boxShadow: '0 0 15px #39ff1480' }
              : { border: '1px solid rgba(57,255,20,0.3)', color: '#39ff14' }
            }
          >
            <i className="ri-flashlight-line" />
            ЗАБРАТЬ СЕГОДНЯ
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">

          {/* Map */}
          <div
            className="lg:col-span-3 rounded-2xl overflow-hidden relative"
            style={{ border: `1px solid ${color}20`, height: '480px' }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14196.553427399427!2d37.616!3d55.758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sru!2sru!4v1711000000000!5m2!1sru!2sru"
              width="100%"
              height="100%"
              style={{ filter: 'invert(90%) hue-rotate(180deg) saturate(0.7) brightness(0.85)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Карта аптек"
            />

            {/* Map overlay controls */}
            <div className="absolute top-4 left-4 flex flex-col gap-2">
              {filtered.map(p => (
                <button
                  key={p.id}
                  onClick={() => setSelectedId(p.id === selectedId ? null : p.id)}
                  className="whitespace-nowrap flex items-center gap-2 px-3 py-1.5 rounded-full cursor-pointer transition-all duration-200 text-left"
                  style={{
                    background: selectedId === p.id ? color : 'rgba(5,5,8,0.88)',
                    border: `1px solid ${p.inStock ? '#39ff1440' : 'rgba(255,255,255,0.1)'}`,
                    boxShadow: selectedId === p.id ? `0 0 10px ${color}` : 'none',
                    backdropFilter: 'blur(10px)',
                  }}
                >
                  <i
                    className="ri-map-pin-fill text-xs"
                    style={{ color: p.inStock ? '#39ff14' : '#ff2d78' }}
                  />
                  <span className="font-mono text-[10px] text-white/80">{p.distance} км</span>
                  <span className="font-orbitron font-bold text-[10px]" style={{ color: selectedId === p.id ? '#050508' : color }}>
                    {p.price.toLocaleString()}₽
                  </span>
                </button>
              ))}
            </div>

            {/* Selected pharmacy popup */}
            {selectedPharmacy && (
              <div
                className="absolute bottom-4 left-4 right-4 p-4 rounded-xl"
                style={{ background: 'rgba(5,5,8,0.94)', border: `1px solid ${color}40`, backdropFilter: 'blur(20px)', boxShadow: `0 0 20px ${color}20` }}
              >
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <div className="font-orbitron font-bold text-xs text-white mb-0.5">{selectedPharmacy.name}</div>
                    <div className="font-mono text-[11px] text-white/40">{selectedPharmacy.address}</div>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full" style={{ background: selectedPharmacy.openNow ? '#39ff14' : '#ff2d78', boxShadow: selectedPharmacy.openNow ? '0 0 6px #39ff14' : '' }} />
                    <span className="font-mono text-[11px]" style={{ color: selectedPharmacy.openNow ? '#39ff14' : '#ff2d78' }}>
                      {selectedPharmacy.openNow ? 'Открыто' : 'Закрыто'}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="font-mono text-[11px] text-white/30 mr-2">{selectedPharmacy.hours}</span>
                    {selectedPharmacy.canPickupToday && (
                      <span className="font-mono text-[10px] px-2 py-0.5 rounded-full" style={{ background: 'rgba(57,255,20,0.1)', color: '#39ff14', border: '1px solid rgba(57,255,20,0.3)' }}>
                        Забрать сегодня
                      </span>
                    )}
                  </div>
                  <span className="font-orbitron font-bold text-base" style={{ color }}>{selectedPharmacy.price.toLocaleString()}₽</span>
                </div>
              </div>
            )}
          </div>

          {/* List */}
          <div className="lg:col-span-2 flex flex-col gap-3 overflow-y-auto" style={{ maxHeight: '480px' }}>
            {filtered.length === 0 && (
              <div className="flex flex-col items-center justify-center h-full text-center py-12">
                <i className="ri-store-2-line text-4xl text-white/10 mb-3" />
                <p className="font-mono text-sm text-white/30">Нет доступных аптек для самовывоза сегодня</p>
              </div>
            )}
            {filtered.map(pharmacy => (
              <button
                key={pharmacy.id}
                onClick={() => setSelectedId(pharmacy.id === selectedId ? null : pharmacy.id)}
                className="text-left p-4 rounded-xl cursor-pointer transition-all duration-300 w-full"
                style={{
                  background: selectedId === pharmacy.id ? `${color}10` : 'rgba(255,255,255,0.02)',
                  border: selectedId === pharmacy.id ? `2px solid ${color}` : '2px solid rgba(255,255,255,0.06)',
                  boxShadow: selectedId === pharmacy.id ? `0 0 15px ${color}20` : 'none',
                }}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <div
                        className="w-2 h-2 rounded-full shrink-0"
                        style={{
                          background: pharmacy.inStock ? '#39ff14' : '#ff2d78',
                          boxShadow: pharmacy.inStock ? '0 0 6px #39ff14' : '0 0 6px #ff2d78',
                        }}
                      />
                      <span className="font-orbitron font-bold text-xs text-white truncate">{pharmacy.name}</span>
                    </div>
                    <div className="font-mono text-[11px] text-white/40 pl-4">{pharmacy.address}</div>
                  </div>
                  <div className="text-right shrink-0 ml-3">
                    <div className="font-orbitron font-bold text-sm" style={{ color: pharmacy.inStock ? color : 'rgba(255,255,255,0.2)' }}>
                      {pharmacy.inStock ? `${pharmacy.price.toLocaleString()}₽` : '—'}
                    </div>
                    <div className="font-mono text-[10px] text-white/30">{pharmacy.distance} км</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 flex-wrap pl-4">
                  <span
                    className="font-mono text-[10px] px-2 py-0.5 rounded-full"
                    style={{
                      background: pharmacy.openNow ? 'rgba(57,255,20,0.1)' : 'rgba(255,45,120,0.1)',
                      color: pharmacy.openNow ? '#39ff14' : '#ff2d78',
                      border: `1px solid ${pharmacy.openNow ? 'rgba(57,255,20,0.3)' : 'rgba(255,45,120,0.3)'}`,
                    }}
                  >
                    {pharmacy.openNow ? 'Открыто' : 'Закрыто'} · {pharmacy.hours}
                  </span>
                  {pharmacy.canPickupToday && pharmacy.inStock && (
                    <span
                      className="font-mono text-[10px] px-2 py-0.5 rounded-full"
                      style={{ background: 'rgba(0,245,255,0.1)', color: '#00f5ff', border: '1px solid rgba(0,245,255,0.3)' }}
                    >
                      <i className="ri-flashlight-line mr-0.5" />
                      Сегодня
                    </span>
                  )}
                  {!pharmacy.inStock && (
                    <span className="font-mono text-[10px] px-2 py-0.5 rounded-full" style={{ background: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.1)' }}>
                      Нет в наличии
                    </span>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PharmacyMap;
